'use client';

import { FC, ReactNode } from 'react';

import { usePathname } from 'next/navigation';

import { getSegment, TeliaSegment } from '@telialt/utils/src/segment';

type Props = {
    children: ReactNode;
};

const getLangFromSegment = (segment: TeliaSegment) => {
    if (segment === TeliaSegment.English) {
        return 'en';
    }
    if (segment === TeliaSegment.Russian) {
        return 'ru';
    }

    return 'lt';
};

export const HtmlLang: FC<Props> = ({ children }) => {
    const path = usePathname();

    return (
        <html lang={getLangFromSegment(getSegment(path))} suppressHydrationWarning={true}>
            {children}
        </html>
    );
};
